// extracted by mini-css-extract-plugin
export default {"tabLinks":"Stuff_tabLinks__E6w9+","button_wrapper":"Stuff_button_wrapper__21gEe","stuff_container":"Stuff_stuff_container__xVRbx","stuff_wrapper":"Stuff_stuff_wrapper__ee-9f"};